import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom';
import Footer from "../../../components/user/Footer/Footer";
import Header from "../../../components/user/Header/Header";
import { withRouter } from 'react-router-dom';
import restApi from '../../../api/Source';
import LoadingSpinner from '../../../components/user/LoadingSpinner/LoadingSpinner';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faTimes } from '@fortawesome/free-solid-svg-icons';

import './ProductList.css';


function ProductList(props) {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [commercialAdaos, setCommercialAdaos] = useState(0);

    // the code of the product from url
    const { articleNumber } = useParams();

    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);

    // list of unique brands found in products
    let filterBrands = [];
    const [brandFilterName, setBrandFilterName] = useState("");

    const [isBrandFilterActive, setIsBrandFilterActive] = useState(false);
    const [isPriceFilterActive, setIsPriceFilterActive] = useState(false);

    const [sortType, setSortType] = useState("");

    const navigateTo = (page) => {
        props.history.push(page);
    }

    if (localStorage.getItem("isAuthenticated") === false || localStorage.getItem("userRole") !== "USER") {
        navigateTo('/');
    }

    useEffect(() => {
        window.scroll(0, 0);
        if (localStorage.getItem("commercialAdaos") !== null && localStorage.getItem("commercialAdaos") !== undefined) {
            setCommercialAdaos(localStorage.getItem("commercialAdaos"));
        }
        console.log(commercialAdaos);
        if (articleNumber !== 'main') {
            setLoading(true);
            restApi.get("/services/articles?includeCrossReferences=" + true + "&&articleNumber=" + articleNumber).then(products => {
                setProducts(products.data)
                setFilteredProducts(products.data);
                setLoading(false);
            }).catch(error => {
                setLoading(false);
                setError(error);
                if (error.response.status === 401) {
                    navigateTo('/');
                }
            });
        }
        if (!localStorage.getItem("cart")) {
            props.setCart([]);
        }
    }, []);

    if (products) {
        products.map(product => {
            if (filterBrands.indexOf(product.supplierBrand) === -1) {
                filterBrands.push(product.supplierBrand);
            }
        });
    }

    const addToCart = (product) => {
        props.addToCart(product);
    }

    // Filters
    const filterProductsByBrand = (brandName) => {
        if (brandName === "none") {
            setFilteredProducts(products);
        } else {
            if (filteredProducts !== products) {
                setFilteredProducts(products.filter(product => product.supplierBrand === brandName));
            } else {
                setFilteredProducts(filteredProducts.filter(product => product.supplierBrand === brandName));
            }
        }
    }

    const filterProductsByPrice = (sortType) => {
        console.log(filteredProducts);
        if (sortType === "none") {
            setFilteredProducts(products);
        } else if (sortType === "asc") {
            if (filteredProducts !== products) {
                setFilteredProducts(filteredProducts.sort((a, b) => (a.price - b.price)));
            } else {
                setFilteredProducts(products.sort((a, b) => (a.price - b.price)));
            }
        } else if (sortType === "desc") {
            if (filteredProducts !== products) {
                setFilteredProducts(filteredProducts.sort((a, b) => (b.price - a.price)));
            } else {
                setFilteredProducts(products.sort((a, b) => (b.price - a.price)));
            }
        }
        console.log(filteredProducts);
    }    

    const handleSortByBrand = (brand) => {
        filterProductsByBrand(brand);
        setIsBrandFilterActive(true);
        setBrandFilterName(brand);
    }

    const handleSortByPrice = (sortType) => {
        filterProductsByPrice(sortType);
        setIsPriceFilterActive(true);
        setSortType(sortType);
    }

    const removeBrandFilter = () => {
        filterProductsByBrand("none");
        setIsBrandFilterActive(false);
        setBrandFilterName("");
    }

    const removePriceFilter = () => {
        filterProductsByPrice("none");
        setIsPriceFilterActive(false);
        setSortType("");
    }

    return (
        <div className="page-container">
            <div id="content-wrap">
                <Header {...props} />
                {isLoading === true && 
                    <LoadingSpinner />
                }
                {isLoading === false && 
                    <div className="container-fluid mt-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-info mb-3" role="alert">
                                    <small className="d-block mb-1"><strong>*</strong> Produsele comandate pana la ora 10:00 din stocul BG1 se vor livra incepand cu ora 11:30</small>
                                    <small className="d-block mb-0"><strong>*</strong> Program livrare stoc RO: 09:00 - 11:00 - 13:00 - 15:00 - 17:00</small>
                                </div>
                            </div>
                        </div>

                        {filteredProducts.length === 0 && products.length > 0 ? (
                            <div className="row">
                                <div className="col-12">
                                    <div className="text-center py-5">
                                        <h5 className="mb-3">Nu s-au găsit produse</h5>
                                        <p className="text-muted mb-4">Nu există produse care să corespundă filtrelor selectate.</p>
                                        {(isPriceFilterActive || isBrandFilterActive) && (
                                            <button 
                                                className="btn btn-primary" 
                                                onClick={() => {removePriceFilter(); removeBrandFilter();}}
                                            >
                                                Elimina filtrele
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : filteredProducts.length === 0 && products.length === 0 ? (
                            <div className="row">
                                <div className="col-12">
                                    <div className="text-center py-5">
                                        <h5 className="mb-3">Nu există produse disponibile</h5>
                                        <p className="text-muted">Momentan nu sunt produse disponibile pentru acest articol.</p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h6 className="card-title mb-3">Filtreaza produsele</h6>
                                                <div className="d-flex flex-wrap mb-3">
                                                    <Dropdown className="mr-2 mb-2">
                                            <DropdownButton
                                                            variant="outline-secondary"
                                            title="Brand"
                                                            onSelect={handleSortByBrand}
                                                        >
                                                {filterBrands.map((brand) =>
                                                                <Dropdown.Item key={brand} eventKey={brand}>{brand}</Dropdown.Item>
                                                )}
                                            </DropdownButton>
                                        </Dropdown>
                                                    <Dropdown className="mb-2">
                                            <DropdownButton
                                                            variant="outline-secondary"
                                            title="Pret"
                                                            onSelect={handleSortByPrice}
                                                        >
                                                <Dropdown.Item eventKey="asc">Ascendent</Dropdown.Item>
                                                <Dropdown.Item eventKey="desc">Descendent</Dropdown.Item>
                                            </DropdownButton>
                                        </Dropdown>
                                    </div>
                                                
                                                {(isBrandFilterActive || isPriceFilterActive) && (
                                                    <div className="d-flex flex-wrap align-items-center">
                                                        <small className="text-muted mr-2">Filtre active:</small>
                                                        {isBrandFilterActive && (
                                                            <Badge pill variant="primary" className="d-inline-flex align-items-center mr-2 mb-2">
                                                                Brand: {brandFilterName}
                                                                <button 
                                                                    className="btn btn-sm p-0 ml-2 text-white" 
                                                                    style={{ background: 'none', border: 'none', fontSize: '0.8rem' }}
                                                                    onClick={(e) => { e.stopPropagation(); removeBrandFilter(); }}
                                                                >
                                                                    <FontAwesomeIcon icon={faTimes} />
                                                                </button>
                                                            </Badge>
                                                        )}
                                                        {isPriceFilterActive && (
                                                            <Badge pill variant="info" className="d-inline-flex align-items-center mr-2 mb-2">
                                                                Pret: {sortType === 'asc' ? 'Ascendent' : 'Descendent'}
                                                                <button 
                                                                    className="btn btn-sm p-0 ml-2 text-white" 
                                                                    style={{ background: 'none', border: 'none', fontSize: '0.8rem' }}
                                                                    onClick={(e) => { e.stopPropagation(); removePriceFilter(); }}
                                                                >
                                                                    <FontAwesomeIcon icon={faTimes} />
                                                                </button>
                                                            </Badge>
                                                        )}
                                                        <button 
                                                            className="btn btn-sm btn-link p-0 ml-2" 
                                                            onClick={() => {removePriceFilter(); removeBrandFilter();}}
                                                        >
                                                            Elimina toate
                                                        </button>
                                </div>
                                                )}
                                    </div>
                                    </div>
                                    </div>
                            </div>
                            
                                <div className="row">
                                    {filteredProducts.map((product) => (
                                        <div key={`${product.supplierId}-${product.articleNumber}`} className="col-12 mb-3">
                                            <div className="card shadow-sm product-card h-100">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-12 col-md-2 mb-3 mb-md-0 text-center">
                                                            {product.media && product.media.type === "1" ? (
                                                                <img 
                                                                    src={`/media/img/${product.media.source}`} 
                                                                    className="img-fluid" 
                                                                    alt={product.productName}
                                                                    style={{ maxHeight: '150px', objectFit: 'contain' }}
                                                                />
                                                            ) : (
                                                                <div className="bg-light d-flex align-items-center justify-content-center" style={{ height: '150px' }}>
                                                                    <span className="text-muted small">Fără imagine</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="col-12 col-md-6 mb-3 mb-md-0">
                                                            <a 
                                                                href={`/product/${encodeURIComponent(product.supplierId)}/${encodeURIComponent(product.articleNumber)}`}
                                                                className="text-decoration-none text-dark"
                                                            >
                                                                <h6 className="font-weight-bold mb-1">{product.productName}</h6>
                                                                <p className="text-muted small mb-1">{product.supplierBrand}</p>
                                                                <p className="text-secondary small mb-0">{product.articleNumber}</p>
                                                            </a>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <p className="mb-2">
                                                                    <small className="text-muted">Pret cu TVA: </small>
                                                                    <strong className="text-success" style={{ fontSize: '1.1rem' }}>
                                                                        {commercialAdaos > 0 
                                                                            ? (product.price + (product.price * commercialAdaos / 100)).toFixed(2)
                                                                            : product.price.toFixed(2)
                                                                        } RON
                                                                    </strong>
                                                                </p>
                                                            </div>
                                                            <div className="mb-3">
                                                                {product.stockBG1 !== null && product.stockBG1 > 0 && (
                                                                    <Badge variant="success" className="mr-1 mb-1" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>BG1: {product.stockBG1}</Badge>
                                                                )}
                                                                {product.stockBG2 !== null && product.stockBG2 > 0 && (
                                                                    <Badge variant="info" className="mr-1 mb-1" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>BG2: {product.stockBG2}</Badge>
                                                                )}
                                                                {product.stockProviders !== null && product.stockProviders > 0 && (
                                                                    <Badge variant="warning" className="mb-1" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>RO: {product.stockProviders}</Badge>
                                                                )}
                                                            </div>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-primary btn-sm btn-block" 
                                                                onClick={() => addToCart(product)}
                                                            >
                                                                <FontAwesomeIcon icon={faShoppingCart} className="mr-1" />
                                                                Adauga in cos
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                </div>
                                    ))}
                                    </div>
                                </>
                        )}
                    </div>
                }
            </div>
            <Footer />
        </div>
    )
}

export default withRouter(ProductList);